import PropTypes from 'prop-types';
import React from 'react';

import { useTranslation } from '../../hooks/useTranslation';
import styles from './styles.module.styl';

const Requirements = ({ list }) => {
  const { t } = useTranslation('core');

  return (
    <div className={styles.requirements}>
      <span className={styles.title}>{t('quickstarts.requirements.systemRequirements', 'System requirements: ')}</span>
      <span>{list.join(' | ')}</span>
    </div>
  );
};

Requirements.propTypes = {
  list: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Requirements;
